import { put, call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* eventSnooze(action: ActionInterface): any {
  try {
    const res = yield call(Http.put, `event/snooze/${action.payload?.event.id}`, {
      snoozeDate: action.payload?.snoozeDate
    });

    yield put({
      type: Constants.GLOBAL_EVENT_SNOOZE_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-event-snoozed-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchEventSnooze() {
  yield takeEvery(Constants.GLOBAL_EVENT_SNOOZE_START, eventSnooze);
}
